const images = {
    logo: require('../assets/images/logoblue.png'),
    avt: require('../assets/images/avt.jpg'),
    avatar1: require('../assets/images/avatar1.jpg'),
    serviceprovider: require('../assets/images/serviceprovider.png')
}

export default images